<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getBranchCod,
  getSearchConfig,
  batchRemarks,
  createBranchBill,
  createClientBill,
  batchHang,
  batchCancelHang,
	sync
} from "@/api/branch/cod";
import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { getCompanyConfig } from "@/api/user/branch";
export default {
  name: "branch_cod",
  components: {
    cTable
  },
  async mounted() {
    let companiesList = (await getCompanyConfig()).data.payload.company;
    let data = (await getSearchConfig()).data.payload;
		let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
		let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    let agent = (await getAgent()).data.payload.rows;
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    this.header.searchs.forEach(item => {
			if (item.key === "from_country") item.options = fromCountry;
			if (item.key === "to_country") item.options = toCountry;
      if (item.key === "client_id") item.options = client;
      if (item.key === "deliver") item.options = agent;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "ownership") item.options = companiesList;
      if (item.key === "cod_status")
        item.options = Object.keys(data.cod_status).map(item => ({
          value: item,
          label: data.cod_status[item]
        }));
      if (item.key === "status_flag")
        item.options = Object.keys(data.status_flag).map(item => ({
          value: item,
          label: data.status_flag[item]
        }));
      if (item.key === "cod_ncnd_status")
        item.options = Object.keys(data.cod_ncnd_status).map(item => ({
          value: item,
          label: data.cod_ncnd_status[item]
        }));
    });
  },
  data() {
    return {
      config: {
        children: true
      },
      methods: {
        list: getBranchCod,
        batchHang,
        getCountry,
        getAllClient,
        getAgent,
        getSearchConfig,
        batchRemarks,
        createBranchBill,
        createClientBill,
        getCompanyConfig,
        batchCancelHang,
				sync
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map(
                item => item.airway_bill_number
              );
              this.$page
                .handleRequestMethods(
                  data.type == "RECEIVE"
                    ? "createBranchBill"
                    : "createClientBill",
                  data,
									true,true
                )
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  message: "Type cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("type"),
              key: "type",
              component: "Radio",
              options: [
                { label: this.$t("receivable"), value: "RECEIVE", id: 692 },
                {
                  label: this.$t("bill_close_account_issuing_confirm"),
                  value: "REFUND",
                  id: 693
                }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.airway_number = this.$page.selectAll.map(item => {
                return item.airway_bill_number;
              });
              let type = row.hang ? "batchHang" : "batchRemarks";
              delete row.hang;
              this.$page.handleRequestMethods(type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("hang"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$t("type"),
              key: "type",
              component: "Radio",
              options: [
                { label: this.$t("receivable"), value: "RECEIVE" },
                {
                  label: this.$t("bill_close_account_issuing_confirm"),
                  value: "REFUND"
                }
              ],
              bind: {
                border: true
              },
              show() {
                return this.$page.getModal("hang").title != this.$t("hang");
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              bind: {
                rows: 5,
                type: "textarea"
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
						key: "from_country",
						placeholder() {
							return this.$t("select") + this.$t("from_country");
						},
						component: "Select",
						options: [],
						config: {
							label: "code",
							value: "code",
						},
					},
					{
						key: "to_country",
						placeholder() {
							return this.$t("select") + this.$t("allow_arrive");
						},
						component: "Select",
						options: [],
						config: {
							label: "code",
							value: "code",
						},
					},
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            },
            bind: {
              style: "width:220px",
              multiple: true,
              "max-tag-count": 1
            }
          },
          {
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "deliver",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            component: "Select",
            options: [],
            config: {
              label: "agent_name",
              value: "id"
            }
          },
          {
            key: "salesman_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "cod_status",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            component: "Select",
            options: []
          },
          {
            key: "status_flag",
            placeholder() {
              return this.$t("select") + this.$t("pod") + this.$t("exlType");
            },
            component: "Select",
            options: []
          },
          {
            key: "cod_ncnd_status",
            placeholder() {
              return (
                this.$t("select") + this.$t("cod_ncnd") + this.$t("exlType")
              );
            },
            component: "Select",
            options: []
          },
          {
            key: "finish_start",
            placeholder() {
              return this.$t("pod") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "finish_end",
            placeholder() {
              return this.$t("pod") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "out_start",
            placeholder() {
              return this.$t("out") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "out_end",
            placeholder() {
              return this.$t("out") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "no_type",
            component: "Select",
            options: [
              {
                label: "CNB" + this.$t("waybillNumber"),
                value: "airway_number"
              },
              { label: this.$t("shipperRef"), value: "client_refer_code" },
              { label: this.$t("order_refCode"), value: "agent_refer_code" }
            ],
            clearable: false,
            default: "airway_number",
            bind: {
              style: {
                width: "120px"
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: [692, 693]
            },
            {
              name: () => this.$t("hang"),
              type: "hang",
              fnName: "hang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              id: 696
            },
            {
              name: () => this.$t("cancel") + this.$t("hang"),
              type: "cancelHang",
              fnName: "cancelHang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              id: 695
            },
            {
              name: () => this.$t("Remarks"),
              type: "remarks",
              fnName: "remarks",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              id: 694
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
						{
							name: () => this.$t("synchronous"),
							type: "sync",
							fnName: "sync",
							bind: {
								// icon: "md-checkmark",
								type: "primary"
							}
						}
          ],
          methods: {
						sync() { 
							this.handleRequestMethods("sync",{},true,true).then(res => {
								this.getList();
							});
						},
            export({ searchForm }) {
              let data = searchForm;
              data.export = 1;
              data.ids = this.selectAll.map(item => item.airway_bill_number);
              this.openLoading();
              this.handleRequestMethods("list", data, false, true).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                window.open(this.$globalUrl + res.payload);
              });
            },
            add({ searchForm }) {
              this.getModal("add").open(searchForm);
            },
            hang() {
              this.getModal("hang").open({ hang: true });
            },
            remarks() {
              this.getModal("hang").open({}, function() {
                this.setTitle(this.$t("Remarks"));
              });
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("batchCancelHang", data).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 180,
          copy: true,
          fixed: "left"
          // component: "Button",
          // bind: {
          //   type({ row }) {
          //     return row.error_status == 3 ||
          //       row.cod_ncnd_status == 3 ||
          //       row.cod_status == 3
          //       ? "error"
          //       : "primary";
          //   },
          //   size: "small"
          // },
          // methods: {
          // render({ h, row }) {
          //   return row.airway_bill_number;
          // }
          // click({ row }) {
          //   this.$page
          //     .getModal("showDetails")
          //     .setTitle(row.check_bill_number);
          //   // this.getModal("writeOff").type = "writeOff";
          //   this.$page.getModal("showDetails").open({ row });
          // }
          // }
        },
        {
          name: () => this.$t("outboundTime"),
          key: "billed_time",
          minWidth: 160
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          minWidth: 100
        },
        {
          name: () => this.$t("clientName"),
          key: "client_account",
          align: "left",
          minWidth: 100
        },
        {
          name: () => this.$t("shipperRef"),
          key: "client_refer_code",
          width: 80
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          width: 80
        },
        {
          name: () => this.$t("hang") + this.$t("exlType"),
          key: "error_status_txt",
          width: 80
        },
        {
          name: () => this.$t("hang") + this.$t("Remarks"),
          key: "finance_remarks",
          width: 100
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          width: 100
        },
        {
          name: () => this.$t("finances") + this.$t("personnel"),
          key: "accounting_account",
          width: 100
        },
        {
					name: () => this.$t("from_country"),
					key: "from_country",
					width: 80
				},
				{
					name: () => this.$t("allow_arrive"),
					key: "to_country",
					width: 80
				},
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          width: 80
        },
        {
          name: () => this.$t("agentName"),
          key: "deliver",
          minWidth: 100
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          minWidth: 100
        },
        {
          name: () => this.$t("trajectory"),
          children: [
            {
              name: () => this.$t("tracker_code"),
              key: "trace_status",
              width: 80
            },
            {
              name: () => this.$t("status_time"),
              key: "trace_time",
              minWidth: 170
            }
          ]
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          minWidth: 100
        },
        {
          name: () => this.$t("cod_settlement"),
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "yt_check_bill_number",
              minWidth: 140,
              render: (h, { row }) => {
                if (row.yt_check_bill_number) {
                  return h(
                    "a",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      attrs: {
                        title:
                          this.$t("jump") +
                          this.$t("correspond") +
                          this.$t("bill1")
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: "branch_cod_refund"
                          });
                          this.$store.dispatch(
                            "pageUrl",
                            row.yt_check_bill_number
                          );
                        }
                      }
                    },
                    row.yt_check_bill_number
                  );
                }
              }
            },
            {
              name: () => this.$t("invoiceName"),
              key: "yt_check_bill_account",
              minWidth: 110
            },
            {
              name: () => this.$t("hang") + this.$t("Remarks"),
              key: "cod_client_remark",
              minWidth: 170
            },
            {
              name: () => this.$t("finances") + this.$t("order_desc"),
              key: "cw_client_remarks",
              width: 100
            },
            {
              name: () => this.$t("cod_status"),
              key: "cod_status_txt",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_client_rate"),
              key: "cod_client_rate",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing"),
              key: "bill_close_account_issuing",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing_charge"),
              key: "bill_close_account_issuing_charge",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing_confirm"),
              key: "bill_close_account_issuing_confirm",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_1_time"),
              key: "cod_1_time",
              minWidth: 125
            },
            {
              name: () => this.$t("cod_9_time"),
              key: "cod_9_time",
              minWidth: 125
            }
          ]
        },
        {
          name: () => this.$t("cod_collection"),
          minWidth: 110,
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "ys_check_bill_number",
              minWidth: 140,
              render: (h, { row }) => {
                if (row.ys_check_bill_number) {
                  return h(
                    "a",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      attrs: {
                        title:
                          this.$t("jump") +
                          this.$t("correspond") +
                          this.$t("bill1")
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: "branch_cod_list"
                          });
                          this.$store.dispatch(
                            "pageUrl",
                            row.ys_check_bill_number
                          );
                        }
                      }
                    },
                    row.ys_check_bill_number
                  );
                }
              }
            },
            {
              name: () => this.$t("invoiceName"),
              key: "ys_check_bill_account",
              minWidth: 110
            },
            {
              name: () => this.$t("hang") + this.$t("Remarks"),
              key: "cod_agent_remark",
              minWidth: 100
            },
            {
              name: () => this.$t("finances") + this.$t("order_desc"),
              key: "cw_agent_remarks",
              width: 100
            },
            {
              name: () => this.$t("cod_ncnd_status"),
              key: "cod_ncnd_status_txt",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_agent_rate"),
              key: "cod_agent_rate",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing"),
              key: "bill_proceeds_issuing",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_charge"),
              key: "bill_proceeds_issuing_charge",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_confirm"),
              key: "bill_proceeds_issuing_confirm",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_ncnd_1_time"),
              key: "cod_ncnd_1_time",
              minWidth: 125
            },
            {
              name: () => this.$t("cod_ncnd_9_time"),
              key: "cod_ncnd_9_time",
              minWidth: 125
            }
          ]
        }
      ]
    };
  }
};
</script>
